import { Component, Input, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { userdeniedService } from '../../services/userdenied.service'; 
import { AuthService } from '../../services/auth.service';  
import { ToastrService } from 'ngx-toastr';

export interface User {
  email?: string;
  userName?: string;
  title?: string;
  ROLE?: string;
}

@Component({
  selector: 'app-denied',
  templateUrl: './denied.component.html',
  styleUrls: ['./denied.component.scss']
})
export class DeniedComponent implements OnInit {
   @Input() user: User | null = {  
   userName: '',  
   email: 'username@deloitte.com',  
   title: ''  
 }; 
  userObj: any = {}; // Replace with actual user object type
  currentRouteGlobal: any; // Replace with actual route details type
  nonAppUser: string = ''; // Set this appropriately

  constructor(
    private http: HttpClient,
    //private routeConfigService: RouteConfigService,
    //private commonService: CommonService,
    //private utilsService: UtilsService,
    private toastr: ToastrService,
    private userdeniedService: userdeniedService,
    private authService: AuthService
  ) {}

  ngOnInit(): void {
    this.sendADMail();
  }

  sendADMail(): void {
    let uName = '';
    const pageDetails = this.currentRouteGlobal;
    let pageName = pageDetails?.title;
    let userEmail = pageDetails?.userEmail === undefined ? this.userObj.email : pageDetails.userEmail;

    if (!pageName) {
      pageName = 'CMP Application';
    }

    if (!this.userObj.userName) {

      this.authService.fetchAndCacheUserProfile().subscribe((data: any) => {
          if (data) {
            uName = data?.value?.[0]?.displayName;
           userEmail = data?.value?.[0]?.mail;
           this.sendAccessDeniedMail(uName, userEmail, pageName);
          }
        }); 
      
    } else {
      uName = this.userObj.userName;
      this.sendAccessDeniedMail(uName, userEmail, pageName);
    }
  }

  private sendAccessDeniedMail(uName: string, userEmail: string, pageName: string): void {

      this.userdeniedService.sendEmail(uName,userEmail,pageName).subscribe((data: any) => {  
         if (data) {  
          this.toastr.warning('QRM team has been intimated of access being denied to you.');
         }  
         else{
          this.toastr.error('QRM team could not be intimated of the access denied issue please reach out to your Engagement Leader');
         }
       },(error: any) => { 
        this.toastr.error('QRM team could not be intimated of the access denied issue please reach out to your Engagement Leader');
       }); 


  }
}
